import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initPcObj = { id: 0, fileId: 0, filename: "", uploading: 1, actionTime: 0, uploadMessageId: "uploadingMsg" };
const initialState = {
    order: [],
    error: null,
    pcObj: initPcObj,
    pcObjMaster: initPcObj,
    uploadState: 'uploading',
    uploadStateMaster: 'uploading',
    // uploadedObj: {},
    uploadedObj: null,
    formState: 'closed'
};

const uploadFile = (state = initialState, action) => {
    return [].concat(state, action.obj)
}

const uploadFileToOneClip = (state = initialState, action) => {
    return [].concat(state, action.obj)
}

const uploadFileSuccess = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploaded'
    });
}

const uploadFileSuccessMaster = (state, action) => {
    return updateObject(state, {
        uploadStateMaster: 'uploaded'
    });
}

const uploadFileProgress = (state, action) => {
    return updateObject(state, {
        pcObj: action.pcObj
    });
}

const uploadFileProgressMaster = (state, action) => {
    return updateObject(state, {
        pcObjMaster: action.pcObj
    });

}

const uploadSetState = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploading',
        pcObj: initPcObj,
        error: null
    });
}

const uploadSetStateMaster = (state, action) => {
    return updateObject(state, {
        uploadStateMaster: 'uploading',
        pcObjMaster: initPcObj,
        error: null
    });
}

const uploadFormState = (state, action) => {
    return updateObject(state, {
        formState: action.payload.formState
    });
}

const uploadFileFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        uploadState: 'uploadFileFail',
    });
}

const uploadFileFailMaster = (state, action) => {
    return updateObject(state, {
        error: action.error,
        uploadStateMaster: 'uploadFileFail',
    });
}

const uploadFileAborted = (state, action) => {
    return updateObject(state, {
        uploadState: 'aborted',
    });
}

const uploadFileAbortedMaster = (state, action) => {
    return updateObject(state, {
        uploadStateMaster: 'aborted',
    });
}

const uploadImportFileFail = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploadImportFileError',
        error: action.error
    });
}

const uploadImportFileFailMaster = (state, action) => {
    return updateObject(state, {
        uploadStateMaster: 'uploadImportFileError',
        error: action.error
    });
}

const uploadEditClipFail = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploadEditClipError',
        error: action.error
    });
}

const uploadProjectAddClipFail = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploadProjectAddClipError',
        error: action.error
    });
}

const uploadRoomAddClipFail = (state, action) => {
    return updateObject(state, {
        uploadState: 'uploadRoomAddClipError',
        error: action.error
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPLOAD_FILE:
            return uploadFile(state, action);
        case actionTypes.UPLOAD_FILE_TO_ONECLIP:
            return uploadFileToOneClip(state, action);
        case actionTypes.UPLOAD_FILE_SUCCESS:
            return uploadFileSuccess(state, action);
        case actionTypes.UPLOAD_FILE_SUCCESS_MASTER:
            return uploadFileSuccessMaster(state, action);
        case actionTypes.UPLOAD_FILE_PROGRESS:
            return uploadFileProgress(state, action);
        case actionTypes.UPLOAD_FILE_PROGRESS_MASTER:
            return uploadFileProgressMaster(state, action);
        case actionTypes.UPLOAD_SET_STATE:
            return uploadSetState(state, action);
        case actionTypes.UPLOAD_SET_STATE_MASTER:
            return uploadSetStateMaster(state, action);
        case actionTypes.UPLOAD_FILE_FAIL:
            return uploadFileFail(state, action);
        case actionTypes.UPLOAD_FILE_FAIL_MASTER:
            return uploadFileFailMaster(state, action);
        case actionTypes.UPLOAD_FILE_ABORTED:
            return uploadFileAborted(state, action);
        case actionTypes.UPLOAD_FILE_ABORTED_MASTER:
            return uploadFileAbortedMaster(state, action);
        case actionTypes.UPLOAD_IMPORT_FILE_FAIL:
            return uploadImportFileFail(state, action);
        case actionTypes.UPLOAD_IMPORT_FILE_FAIL_MASTER:
            return uploadImportFileFailMaster(state, action);
        case actionTypes.UPLOAD_EDIT_CLIP_FAIL:
            return uploadEditClipFail(state, action);
        case actionTypes.UPLOAD_PROJECT_ADD_CLIP_FAIL:
            return uploadProjectAddClipFail(state, action);
        case actionTypes.UPLOAD_ROOM_ADD_CLIP_FAIL:
            return uploadRoomAddClipFail(state, action);
        case actionTypes.UPLOAD_SAVE_UPLOADEDDATA:
            return { ...state, uploadedObj: action.payload };
        case actionTypes.UPLOAD_FORM_STATE:
            return uploadFormState(state, action);
        default:
            return state;
    }
}

export default reducer;



